
    <h1 mat-dialog-title>
        <mat-icon class="close-icon" mat-dialog-close>close</mat-icon>
        Bio
    </h1>
    <div mat-dialog-content>
        <p>
          Soy Actor, Voice Artist, Comediante y  Speaker. Un Artista Multifacético y Empresario, amante de la comedia que ha trabajado por más de 15 años en la industria del entretenimiento de Latinoamérica.   
        </p>
        <p>
          He creado, escrito, producido, actuado, y dirigido contenidos en distintos formatos, para llegar a millones de personas a través del entretenimiento.
        </p>
        <p>
          Soy un hombre universal que ama expresarse artísticamente con un lenguaje que funcione en todo el planeta; y lo hago porque es mi forma de darle al mundo maravillas.
        </p>
        <div class="slogan" >      
          ¡La vida brilla si le pones comedia!      
      </div> 
    </div>   
    